import { render } from "./ResponsePrefill.vue?vue&type=template&id=0c16210b"
import script from "./ResponsePrefill.vue?vue&type=script&lang=js"
export * from "./ResponsePrefill.vue?vue&type=script&lang=js"
script.render = render

export default script